module.exports = __webpack_public_path__ + "static/media/guide_4.0280e4ab.png";